'use strict';

function AdminChangeManagerController($modal, userService, $log, $q) {
  var vm = this;
  vm.$onInit = $onInit;
  vm.loading = false;
  vm.translationsDone = false;
  vm.showUserTable = false;
  vm.groups = [];
  vm.managers = [];
  vm.targetManagers = [];
  vm.selectedUsers = [];
  vm.originalManager = undefined;
  vm.newManager = undefined;

  function $onInit() {
    refreshUsers();
  }

  function refreshUsers() {
    vm.managers = [];
    userService.list().then(function (response) {
      vm.users = response.data;
      vm.users.forEach(function(user) {
        if(user.first_name !== '' || user.last_name !== '') {
          user.fullName = user.first_name + ' ' + user.last_name;
        } else {
          user.fullName = user.email;
        }
        user.groups.forEach(function(group) {
          if(group.name === 'Cenceo Manager') {
            vm.managers.push(user);
          }
        });
      });
    });
  }

  vm.selectOriginalManager = function() {
    userService.getEmployeesOfManager(vm.originalManager.id).then(function (response) {
      vm.availableUsers = response;
      vm.selectedUsers = [];
      vm.targetManagers = vm.managers.slice();
      var index = vm.targetManagers.indexOf(vm.originalManager);
      if (index > -1) {
        vm.targetManagers.splice(index, 1);
      }
    });
  };

  vm.toggle = function (item) {
    var idx = vm.selectedUsers.indexOf(item);
    if (idx > -1) {
      vm.selectedUsers.splice(idx, 1);
    }
    else {
      vm.selectedUsers.push(item);
    }
  };

  vm.exists = function (item, list) {
    for(var i = 0; i < list.length; i++) {
      if (list[i].id === item.id) {
        return true;
      }
    }
    return false;
  };

  vm.selectAll = function() {
    if(vm.selectedUsers.length === vm.availableUsers.length) {
      vm.selectedUsers = [];
    } else {
      vm.selectedUsers = vm.availableUsers.slice();
    }
  };

  vm.changeManager = function() {
    var changeManagerRequests = [];
    vm.selectedUsers.forEach(function(user) {
      changeManagerRequests.push(userService.changeManager(vm.originalManager.id, user.id, vm.newManager.id));
    });
    $q.all(changeManagerRequests).then(function () {
      vm.selectOriginalManager();
    }).catch(function (error) {
      vm.selectOriginalManager();
      $log.log(error.data.error);
    });
  };

}

module.exports = AdminChangeManagerController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/admin/users/change-manager/change-manager.controller.js
 ** module id = 161
 ** module chunks = 0
 **/